import { AnimatedIllustrationWrapper } from '../AnimatedIllustrationWrapper';
import type { AnimatedIllustrationProps } from '../types';

export const CollaborationCreationAnimated = ({
  'aria-label': ariaLabel,
  ...props
}: AnimatedIllustrationProps) => {
  return (
    <AnimatedIllustrationWrapper
      src="https://static.mentimeter.com/static/images/animated_illustration_collaboration_creation.webp"
      type="spotlight"
      aria-label={ariaLabel || 'Collaboration'}
      {...props}
    />
  );
};
